import { ReactNode } from 'react'
import { Link as RouterLink } from 'wouter'

export const LinkWrapper = ({
  to,
  children,
}: {
  to: string
  children: ReactNode
}) => {
  return (
    <RouterLink
      to={to}
      style={{
        textDecoration: 'none',
      }}
    >
      {children}
    </RouterLink>
  )
}
